module.exports = __webpack_public_path__ + "img/news4.ade74024.png";